import {svgIconWrapper} from '../svg-icon-wrapper';

import MegaphoneRegular from './megaphone-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <MegaphoneRegular {...props} />;
}
SvgComponent.iconName = 'megaphoneRegular';

export const MegaphoneRegularIcon = svgIconWrapper(SvgComponent);
